document.addEventListener("DOMContentLoaded", function () {

  const slides = document.querySelectorAll("slideshow-slide");
  let autoResumeTimeout;

  function getSlideshow() {
    return document.querySelector("slideshow-component");
  }

  function stopAutoplay() {
    const slideshow = getSlideshow();
    if (!slideshow) return;
    slideshow.setAttribute("autoplay", "false");
  }

  function startAutoplay() {
    const slideshow = getSlideshow();
    if (!slideshow) return;

    slideshow.setAttribute("autoplay", "true");

    const event = new Event("pointerdown", { bubbles: true });
    slideshow.dispatchEvent(event);
  }

  slides.forEach(function (slide) {

    const closeBtn = document.createElement("button");
    closeBtn.innerHTML = "×";
    closeBtn.className = "slide-close-btn";
    slide.appendChild(closeBtn);

    function closeSlide() {
      slide.classList.remove("slide-expanded");
      clearTimeout(autoResumeTimeout);

      setTimeout(() => {
        startAutoplay();
      }, 300);
    }

    slide.addEventListener("click", function (e) {

      if (e.target.classList.contains("slide-close-btn")) return;

      slides.forEach(s => s.classList.remove("slide-expanded"));
      slide.classList.add("slide-expanded");

      stopAutoplay();
      clearTimeout(autoResumeTimeout);

      autoResumeTimeout = setTimeout(function () {

        closeSlide();

      }, 5000);

    });

    closeBtn.addEventListener("click", function (e) {

      e.stopPropagation();
      closeSlide();

    });

  });

});